module.exports = __webpack_public_path__ + "img/fse-ticker-logo@3x.287a3b51.png";